



















































































































import SDK from './lib/sdk'
import STORAGE from './lib/storage'
import NVis from '../lib/n-vis/NVis.vue'

import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import CrashDirection from '@/components/CrashDirection.vue'
import CarStatus from '@/components/CarStatus.vue'

@Component({
  name: 'App',
  components: {
    CarStatus,
    CrashDirection,
    NVis,
  },
})
export default class App extends Vue {

  public autoRefresh: boolean = false
  public showMap: boolean = false
  public loading = false

  public compactMode: boolean = false

  public raw = null
  public dialog = false

  public authToken: string = ''
  public command: string = ''
  public search: string = ''
  public selection: any = []

  get headers() {
    if (this.compactMode) {
      return [
        {text: 'Note', value: 'Note'},
        {text: 'Serial', value: 'Serial'},
        {text: 'Battery', value: 'DeviceStatus.VehicleStatus.Battery'},
        {text: 'Odometer (km)', value: 'DeviceStatus.VehicleStatus.Odometer'},
        {text: 'Status', value: 'DeviceStatus.Status'},
        {text: 'Statuses', value: 'DeviceStatus.Statuses'},
        {text: 'LastCommand', value: 'LastCommand'},
      ]
    } else {
      return [
        {text: 'Cmd', value: 'Cmd'},
        {text: 'Note', value: 'Note'},
        {text: 'Manager', value: 'Manager'},
        {text: 'Product', value: 'Product'},
        {text: 'Serial', value: 'Serial'},
        {text: 'Last Seen', value: 'LastSeen'},
        {text: 'ConnectionStatus', value: 'DeviceStatus.ConnectionStatus.State'},
        {text: 'Battery', value: 'DeviceStatus.VehicleStatus.Battery'},
        {text: 'Cellular', value: 'Cellular'},
        {text: 'Odometer (km)', value: 'DeviceStatus.VehicleStatus.Odometer'},
        {text: 'Speed (km/h)', value: 'DeviceStatus.VehicleStatus.Speed'},
        {text: 'Range (km)', value: 'DeviceStatus.VehicleStatus.Range'},
        {text: 'Status', value: 'DeviceStatus.Status'},
        {text: 'Statuses', value: 'DeviceStatus.Statuses'},
        {text: 'Position', value: 'DeviceStatus.Position'},
        {text: 'LastCommand', value: 'LastCommand'},
      ]
    }
  }

  public rows: any = []

  public created() {
    this.authToken = STORAGE.load('playcoonnect-token')
    this.setToken()
    if (this.authToken !== '') {
      this.loadData()
    }
  }

  @Watch('authToken')
  public setToken() {
    SDK.setToken(this.authToken)
    STORAGE.save('playcoonnect-token', this.authToken)
  }

  get filtered() {
    return this.rows.filter((i: any) => {
      if (i.Manager === 'PLAIN') {
        return false
      }
      if (this.search.trim() === '') {
        return true
      }
      return i.Serial.includes(this.search) || i.Note.includes(this.search) || this.selection.map((x: any) => x.Serial).includes(i.Serial)
    })
  }


  public loadData() {
    if (this.loading) {
      return
    }
    this.loading = true
    SDK.connections().then((d) => {
      const iddys = this.selection.map((i: any) => {
        return i.Serial
      })
      this.selection = []

      this.rows = Object.values(d.data)

      this.rows.forEach((i: any) => {
        Vue.set(i, 'LastCommand', 'NO COMMAND')
        if (iddys.includes(i.Serial)) {
          this.selection.push(i)
        }
      })

      this.loading = false
      if (this.autoRefresh) {
        setTimeout(() => {
          this.loadData()
        }, 1000)
      }
    }).catch(() => {
      this.loading = false
      if (this.autoRefresh) {
        setTimeout(() => {
          this.loadData()
        }, 1000)
      }
    })

  }

  public toggleAutoRefresh() {
    this.autoRefresh = !this.autoRefresh
    if (this.autoRefresh) {
      this.loadData()
    }
  }

  public runSelection() {
    this.selection.forEach((i: any) => {
      Vue.set(i, 'LastCommand', '...')
      SDK.devices(i.Serial).command(this.command).then((result: any) => {
        Vue.set(i, 'LastCommand', result.data.response)
      }).catch((result: any) => {
        Vue.set(i, 'LastCommand', 'ERROR ' + result.response.status + ': ' + JSON.stringify(result.response.data))
      })
    })
  }

  public run(serial: string, action: string) {
    this.setLastCommand(serial, '...' + action)
    switch (action) {
      case 'sync':
        SDK.sync(serial).then((x) => {
          this.setLastCommand(serial, JSON.stringify(x.data))
        })
        break
      case 'key':
        SDK.key(serial).then((x) => {
          this.setLastCommand(serial, JSON.stringify(x.data))
        })
        break
      case 'key-rotate':
        SDK.rotateKey(serial).then((x) => {
          this.setLastCommand(serial, JSON.stringify(x.data))
        })
        break
    }
  }

  public setLastCommand(serial: string, value: string) {
    this.rows.filter((i: any) => {
      return i.Serial === serial
    }).forEach((i: any) => {
      Vue.set(i, 'LastCommand', value)
    })
  }

  public rowStyle(x: any) {
    switch (x.DeviceStatus.ConnectionStatus.State) {
      case 'CONNECTED':
        return 'row-green'
      case 'DISCONNECTED':
        return 'row-red'
    }
  }

  public rel() {
    location.reload()
  }

  public getColor(p: any) {
    if (p === -1) {
      return
    }
    if (p > 75) {
      return 'green'
    } else if (p > 40) {
      return 'orange'
    } else if (p > 20) {
      return 'yellow'
    } else {
      return 'red'
    }
  }

}
